<div *ngIf="visibility" class="cand-modal modal-info">
    <article [@slideInOut] *ngIf="visibility" class="cand-modal__overlay">
        <span class="cand-modal__overlay__close circle-close-icon" (click)="toggleVisibility()"></span>
        <h1 class="cand-modal__title">
            {{ 'password.title' | i18n }}
        </h1>
        <section>
            <div class="login-page__subtitle">
                {{ 'password.subtitle' | i18n }}
            </div>
            <form method="POST" name="passwordForm" [formGroup]="passwordForm" (ngSubmit)="submitPasswordChange()" class="grid-10 grid-mobile-4">
                <div class="grid-12 login-page__input">
                    <label class="grid-6 grid-mobile-4" for="otp"> {{ 'password.form.currentPassword.label' | i18n }} : </label>
                    <input type="password" class="grid-6 grid-mobile-4 textfield" id="currentPasswordotp" formControlName="currentPasswordotp" name="currentPasswordotp" maxlength="20" required />
                </div>

                <app-password-creation [form]="passwordForm" [label]="'accountactivation.form.password.label' | i18n" [labelRepeat]="'accountactivation.form.repeatPassword.label' | i18n"> </app-password-creation>

                <div class="grid-12 login-page__input simulation__group login-page__button">
                    <button
                        type="submit"
                        id="submit_btn"
                        class="grid-6 push-6 grid-mobile-4 push-mobile-0 button button--primary"
                        data-tag-commander=""
                        [appTagCommander]="'tagCo.password.form.submit.button'"
                        data-api-call-button=""
                        [disabled]="!passwordForm.valid || newPassword.value != repeatPassword.value"
                    >
                        {{ 'password.form.submitbutton' | i18n }}
                    </button>
                </div>
            </form>
        </section>
    </article>
    <div class="cand-modal__fade" *ngIf="visibility" [@fadeInOut] (click)="toggleVisibility()"></div>
</div>

<app-simple-message-modal [modalTitle]="'reset.popup.title'" [content]="'reset.popup.body'" [closeButton]="'reset.popup.yes'" [visibility]="passwordResetSuccess" [centered]="false" [icon]="'iconblock--valid'"> </app-simple-message-modal>
